import { Violet100 } from '@zep-us/zus/tokens';

import { QUIZ_CARD_HEADER_CLASSNAME } from '@/shared/components/QuizCard';

type AiSaveAnimationOptions = {
  scrollTargetId?: string;
  scrollBehavior?: 'auto' | 'smooth';
};

const AI_SAVE_ANIMATION_DELAY_MS = 100;
const AI_SAVE_ANIMATION_MAX_ATTEMPTS = 10;

/**
 * @description ai 문제 생성 애니메이션
 * @param aiSaveQuizId 추가된 문제 리스트들의 id
 */
export const aiSaveAnimation = (
  aiSaveQuizId: string[],
  options: AiSaveAnimationOptions = {},
) => {
  setTimeout(() => {
    runAiSaveAnimation(aiSaveQuizId, options, 0);
  }, AI_SAVE_ANIMATION_DELAY_MS);
};

const runAiSaveAnimation = (
  aiSaveQuizId: string[],
  options: AiSaveAnimationOptions,
  attempt: number,
) => {
  const targetQuizCards = aiSaveQuizId.map(id => document.getElementById(id));
  const mountedQuizCards = targetQuizCards.filter(
    (card): card is HTMLElement => card !== null,
  );

  if (
    mountedQuizCards.length === 0 &&
    attempt < AI_SAVE_ANIMATION_MAX_ATTEMPTS
  ) {
    requestAnimationFrame(() => {
      runAiSaveAnimation(aiSaveQuizId, options, attempt + 1);
    });
    return;
  }

  const scrollTarget =
    document.getElementById(options.scrollTargetId ?? '') ??
    mountedQuizCards[0];

  if (scrollTarget != null) {
    scrollTarget.scrollIntoView({
      behavior: options.scrollBehavior ?? 'smooth',
      block: 'center',
    });
  }

  mountedQuizCards.forEach(card => {
    const header = card.querySelector(`.${QUIZ_CARD_HEADER_CLASSNAME}`);
    if (header) {
      header.classList.add('animate-shine-background');
      header.setAttribute('style', `--shine-background-color: ${Violet100}`);
    }

    setTimeout(() => {
      if (header) {
        header.classList.remove('animate-shine-background');
        header.removeAttribute('style');
      }
    }, 1000);
  });
};
